import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Create axios instance
const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Admin Auth API
export const adminAPI = {
  login: async (email, password) => {
    const response = await api.post('/admin/login', { email, password });
    return response.data;
  },
  
  register: async (email, password, full_name) => {
    const response = await api.post('/admin/register', { email, password, full_name });
    return response.data;
  },
  
  getMe: async () => {
    const response = await api.get('/admin/me');
    return response.data;
  },
};

// Blog API
export const blogAPI = {
  getAll: async (params = {}) => {
    const response = await api.get('/blogs', { params });
    return response.data;
  },
  
  getBySlug: async (slug) => {
    const response = await api.get(`/blogs/${slug}`);
    return response.data;
  },
  
  create: async (blogData) => {
    const response = await api.post('/blogs', blogData);
    return response.data;
  },
  
  update: async (id, blogData) => {
    const response = await api.put(`/blogs/${id}`, blogData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/blogs/${id}`);
    return response.data;
  },
  
  generateAI: async (topic, language = 'en') => {
    const response = await api.post('/blogs/generate', null, {
      params: { topic, language }
    });
    return response.data;
  },
};

// Lead API
export const leadAPI = {
  create: async (leadData) => {
    const response = await api.post('/leads', leadData);
    return response.data;
  },
  
  getAll: async (params = {}) => {
    const response = await api.get('/leads', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/leads/${id}`);
    return response.data;
  },
  
  update: async (id, updateData) => {
    const response = await api.put(`/leads/${id}`, updateData);
    return response.data;
  },
  
  getDashboard: async () => {
    const response = await api.get('/leads/analytics/dashboard');
    return response.data;
  },
};

// Analytics API
export const analyticsAPI = {
  track: async (eventData) => {
    const response = await api.post('/leads/analytics', eventData);
    return response.data;
  },
};

export default api;
